import moment from 'moment'
import { APIClient } from '../'
import type { SearchKeywordImpressionLabel, SearchKeywordImpressionLabelId } from 'src/biz_spa/types'
import type { SearchKeywordImpressionLabelResponse, SearchKeywordImpressionLabelUpdateValues } from './types'

export class SearchKeywordImpressionLabelsAPIClient extends APIClient {
  constructor() {
    super()
  }

  async getLabels(companyUuid: string): Promise<SearchKeywordImpressionLabel[]> {
    const res = await this.get<{ data: SearchKeywordImpressionLabelResponse[] }>(`/api/companies/${companyUuid}/search_keyword_impressions/labels.json`)
    return res.data.data.map((item) => this.mapSearchKeywordImpressionLabel(item))
  }

  async getLabel(companyUuid: string, labelId: SearchKeywordImpressionLabelId) {
    const res = await this.get<{ data: SearchKeywordImpressionLabelResponse }>(`/api/companies/${companyUuid}/search_keyword_impressions/labels/${labelId}.json`)
    return this.mapSearchKeywordImpressionLabel(res.data.data)
  }

  async updateLabel(companyUuid: string, labelId: SearchKeywordImpressionLabelId, values: SearchKeywordImpressionLabelUpdateValues) {
    const res = await this.put<
      { keywords: SearchKeywordImpressionLabelUpdateValues },
      { data: SearchKeywordImpressionLabelResponse }
    >(
      `/api/companies/${companyUuid}/search_keyword_impressions/labels/${labelId}.json`,
      { keywords: values },
    )
    return this.mapSearchKeywordImpressionLabel(res.data.data)
  }

  mapSearchKeywordImpressionLabel(item: SearchKeywordImpressionLabelResponse): SearchKeywordImpressionLabel {
    return {
      ...item,
      updatedAt: item.updatedAt ? moment(item.updatedAt) : null,
    }
  }
}

export * from './types'
